import { useCallback, useEffect, useState } from "react";

import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { auth } from "api";
import {
  getAuthToken,
  type GetAuthTokenData,
  setTokens,
} from "api/authentication";
import { useNavigate } from "hooks/useNavigate";
import { clearCookies } from "utils/auth.util";
import * as LOCAL_STORAGE from "utils/localStorage";

export const useAuth = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loginError, setLoginError] = useState<boolean>(false);

  const getToken = useCallback(
    async (data: GetAuthTokenData) => {
      try {
        const response = await getAuthToken(data);

        // set login error as false
        setLoginError(false);

        if (response.access_token) {
          setTokens(response);

          // Reset all data loading causing useAuthenticatedUser to refetch
          // and AuthLayout to navigate to monitor once the user is fetched
          dispatch(auth.util.resetApiState());
        }
      } catch {
        clearCookies();
        setLoginError(true);
      }
    },
    [dispatch],
  );

  useEffect(() => {
    const code = new URLSearchParams(search).get("code");
    const responseState = new URLSearchParams(search).get("state");
    const userState = new URLSearchParams(search).get("userState");

    const state = sessionStorage.getItem("state");
    const code_verifier = sessionStorage.getItem("code_verifier");
    const client_id = LOCAL_STORAGE.getClientId();
    if (
      userState &&
      responseState &&
      state &&
      code &&
      client_id &&
      code_verifier &&
      !Cookies.get("access_token") &&
      userState === "Authenticated" &&
      state === responseState
    ) {
      getToken({ code, client_id, code_verifier });
    } else {
      navigate("/auth/login");
    }
  }, [getToken, navigate, search]);

  return { loginError };
};
